/**
 * Shared utilities for stakeholder display
 */

/** Default avatar background color */
export const AVATAR_COLOR = '#6E53F9'

/**
 * Get initials from a name (max 2 characters).
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
